import { AgenteReguladoAPI } from "@/api/agente_regulado.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { AgenteRegulado } from "@/models/agente_regulado";

const agenteRegulado = new AgenteReguladoAPI();

const getAll = (): AxiosObservable<AgenteRegulado[]> => {
  return agenteRegulado.getAll();
};

const findByArea = (areadId: number): AxiosObservable<AgenteRegulado[]> => {
  return agenteRegulado.findByArea(areadId);
};

findByArea;

export default {
  getAll,
  findByArea
};
